var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicShowingTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5 Copy 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_mic_2256103 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.5 8.5C5.88004 8.49839 6.99839 7.38004 7 6V2.5C7 1.11929 5.88071 0 4.5 0C3.11929 0 2 1.11929 2 2.5V6C2.00161 7.38004 3.11996 8.49839 4.5 8.5Z",
    fill: "#027BFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.5 5C8.22386 5 8 5.22386 8 5.5V6C8 7.933 6.433 9.5 4.5 9.5C2.567 9.5 1 7.933 1 6V5.5C1 5.22386 0.776142 5 0.5 5C0.223858 5 0 5.22386 0 5.5V6C0.00328574 8.29023 1.72422 10.2136 4 10.4705V13H2C1.72386 13 1.5 13.2239 1.5 13.5C1.5 13.7761 1.72386 14 2 14H7C7.27614 14 7.5 13.7761 7.5 13.5C7.5 13.2239 7.27614 13 7 13H5V10.4705C7.27578 10.2136 8.99671 8.29023 9 6V5.5C9 5.22386 8.77614 5 8.5 5Z",
    fill: "#027BFC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicShowingTimer);
export default __webpack_public_path__ + "static/media/mic_showing_timer.54b86f827962ee87e49dc705e134a1be.svg";
export { ForwardRef as ReactComponent };